import React, { useEffect, useState } from "react";
import { AutoComplete, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./Firebase/FirebaseConnection";

const BookSearchSelect = ({ onSelectBook }) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchBooks = async () => {
      const booksSnapshot = await getDocs(collection(db, "books"));
      const books = booksSnapshot.docs.map((doc) => {
        const data = doc.data();
        const searchText = `${data.title} ${data.author}`.toLowerCase();
        return {
          label: (
            <div>
              <div>
                📘 <strong>{data.title}</strong> by {data.author}
              </div>
              <div style={{ fontSize: "12px", color: "#888" }}>
                🧾 Total: {data.totalCopies || 0} | Available:{" "}
                {data.copiesAvailable || 0}
              </div>
            </div>
          ),
          value: doc.id,
          title: data.title,
          doc,
          searchText, // used for filtering
        };
      });
      setOptions(books);
    };

    fetchBooks();
  }, []);

  return (
    <AutoComplete
      style={{ width: "100%", marginBottom: 16 }}
      options={options}
      placeholder="Search by book title"
      value={inputValue}
      onChange={(val) => setInputValue(val)}
      onClear={() => {
        setInputValue("");
        onSelectBook(null);
      }}
      onSelect={(value, option) => {
        setInputValue(option.title);
        onSelectBook(option.doc);
      }}
      allowClear
      filterOption={(inputValue, option) =>
        option?.searchText?.includes(inputValue.toLowerCase())
      }
    >
      <Input prefix={<SearchOutlined style={{ color: "#888" }} />} allowClear />
    </AutoComplete>
  );
};

export default BookSearchSelect;
